export default class Address {
    public streetAddress: string = '';
    public zipCode: string = '';
    public city: string = '';
    public state: string = '';

    public validAddress() {
        return this.streetAddress && this.zipCode && this.city && this.state;
    }
}